export function filterUserTags(tags, tagDefs) {
  return (tags || []).filter((key) => {
    const def = tagDefs.find((d) => d.key === key);
    return def && !def.auto;
  });
}
